import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import { Variables, variables } from '../../Variables.js';

$(document).on("input", '#playerName', function () {
    const value = $(this).val();
    const data_value = $('#players [value="' + value + '"]').data('value');
    const data_value2 = $('#players [value="' + value + '"]').data('value2');
    const data_value3 = $('#players [value="' + value + '"]').data('value3');
    //alert(data_value);
    $('#playerId').val(data_value);
    $('#playerTeamId').val(data_value2);
    $('#playerTeamAbrev').val(data_value3);
});

$(document).on("input", '#teamName', function () {
        const value = $(this).val();
        const data_value = $('#teams [value="' + value + '"]').data('value');
        const data_value2 = $('#teams [value="' + value + '"]').data('value2');
        //alert(data_value);
        $('#teamId').val(data_value);
        $('#teamAbrev').val(data_value2);
});